/**
 * This file contains the schema for the data returned by our API. This schema is defined using the
 * normalizr library. With the schema defined we can use normalizr to normalise and denormalise the
 * data returned by the server.
 */
import { schema } from "normalizr";

export const device = new schema.Entity("devices");
export const deviceScreenShot = new schema.Entity("deviceScreenShots", {
  device,
});

export const feed = new schema.Entity("feeds");

export const scheduledContent = new schema.Entity("scheduledContent", {
  content: feed,
});
export const scheduledDailyContent = new schema.Entity("scheduledDailyContent", {
  content: feed,
 });
export const specialContent = new schema.Entity("specialContent", {
  content: feed,
});

export const deviceGroup = new schema.Entity("deviceGroups", {
  devices: [device],
  feed,
  schedule: [scheduledContent],
   daily_schedule: [scheduledDailyContent],
   specials: [specialContent],
});


export const deviceUngroupWrapper = new schema.Entity("deviceUngroupWrappers", {
  devices: [device],
  feed,
  schedule: [scheduledContent],
   daily_schedule: [scheduledDailyContent],
   specials: [specialContent],
});

export const campaign = new schema.Entity("campaign");

export const asset = new schema.Entity("assets");

export const webAssetTemplate = new schema.Entity("webAssetTemplates");

export const customWebAssetTemplate = new schema.Entity("customTemplates");

export const scrollerTemplates = new schema.Entity("scrollerTemplates");

export const playlistItem = new schema.Entity("playlistItems", { item: asset });

export const playlist = new schema.Entity("playlists", {
  items: [playlistItem],
}); 

export const playlistV2 = new schema.Entity("playlistsV2");


// export const channelItem = new schema.Entity('channelItems');
// export const channel = new schema.Entity('channels', {items: [channelItem]});
export const channel = new schema.Entity("channels");

export const playlistTag = new schema.Entity("listTags");

export const deviceTag = new schema.Entity("listDeviceTags");

export const assetTag = new schema.Entity("listAssetTags");


export const userReports = new schema.Entity("userReports");


export const ticker = new schema.Entity("tickers");
export const tickerSeries = new schema.Entity("tickerSeries", {
  tickers: [ticker],
});

export const userProfile = new schema.Entity(
  "userProfile",
  {},
  { idAttribute: "username" }
);
export const notification = new schema.Entity("notifications");

export const subUsers = new schema.Entity("subUsers");

export const myClient = new schema.Entity("myClient");

export const profileUser = new schema.Entity("profileUser");

export const assetList = new schema.Entity("assets", {
  results: [asset],
});



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/api/schema.js